import { render, staticRenderFns } from "./storeSetting.vue?vue&type=template&id=21445fb7&scoped=true&"
import script from "./storeSetting.vue?vue&type=script&lang=js&"
export * from "./storeSetting.vue?vue&type=script&lang=js&"
import style0 from "./storeSetting.vue?vue&type=style&index=0&id=21445fb7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21445fb7",
  null
  
)

export default component.exports